import Swiper, {
  Navigation,
  Keyboard,
  Mousewheel,
  Pagination,
  FreeMode
} from 'swiper';
import { Fancybox } from '@fancyapps/ui';

window.Fancybox = Fancybox;

const animatedText = () => {
  const textBlock = document.querySelector('.animated-text');
  let letters = textBlock.querySelectorAll('span');
  textBlock.classList.add('animating');
  letters.forEach((letter, index) => {
    const delay = 100;
    setTimeout(() => {
      letter.classList.add('active');
    }, delay * index);
  });
};

// Loading
window.addEventListener('load', () => {
  window.scroll(0, 0);

  setTimeout(() => {
    const loading = document.querySelector('.loading');
    loading.classList.add('deactivated');
  }, 1000);

  setTimeout(() => {
    animatedText();
  }, 1500);
});

const serviceSlider = document.querySelector('.service-slider');
if (serviceSlider) {
  const nextButton = serviceSlider.querySelector('.service-slider-next');
  const prevButton = serviceSlider.querySelector('.service-slider-prev');
  const pagination = serviceSlider.querySelector('.service-slider-pagination');

  new Swiper(serviceSlider, {
    modules: [Navigation, Keyboard, Mousewheel, Pagination, FreeMode],
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 60,
    slideToClickedSlide: true,
    freeMode: true,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton
    },
    pagination: {
      el: pagination,
      type: 'bullets',
      clickable: true
    },
    keyboard: true,
    mousewheel: {
      forceToAxis: true
    }
  });
}
